import React from 'react';
import './save-dot.scss';

/**
 * Where an edit is on its way to the database. `dirty` is typed but not yet
 * sent (the debounce window), `saving` is in flight, `saved` and `error` are
 * the outcomes. The modal header shows the aggregate; a field shows its own.
 */
export type SaveState = 'idle' | 'dirty' | 'saving' | 'saved' | 'error';

interface SaveDotProps {
  state: SaveState;
  /** Text after the dot. Without it the dot stands alone and the state is its title. */
  label?: string;
  className?: string;
}

const TITLES: Record<SaveState, string> = {
  idle: '',
  dirty: 'Unsaved change',
  saving: 'Saving…',
  saved: 'Saved',
  error: 'Save failed',
};

const SaveDot: React.FC<SaveDotProps> = ({ state, label, className = '' }) => {
  if (state === 'idle' && !label) return null;
  return (
    <span
      className={`save-dot save-dot--${state} ${className}`.trim()}
      role="status"
      aria-label={label ?? TITLES[state]}
      title={label ? undefined : TITLES[state]}
    >
      <span className="save-dot__dot" aria-hidden="true" />
      {label && <span className="save-dot__label">{label}</span>}
    </span>
  );
};

export default SaveDot;
